import { useMemo } from 'react';

export const useFeed = (games = [], highlights = [], posts = []) => {
  const combinedFeed = useMemo(() => {
    const feedItems = [
      ...games.map((game) => ({
        ...game,
        content_type: 'game',
      })),
      ...highlights.map((highlight) => ({
        ...highlight,
        content_type: 'highlight',
      })),
      ...posts.map((post) => ({
        ...post,
        content_type: 'post',
      })),
    ];

    // Sort by date (newest first)
    return feedItems.sort((a, b) => {
      const dateA = a.content_type === 'game' ? new Date(a.date) : new Date(a.created_at);
      const dateB = b.content_type === 'game' ? new Date(b.date) : new Date(b.created_at);
      return dateB - dateA;
    });
  }, [games, highlights, posts]);

  const getFeedByType = (type) => {
    return combinedFeed.filter(item => item.content_type === type);
  };

  const getFeedByUser = (userId) => {
    return combinedFeed.filter(item => item.user?.id === userId);
  };

  const getFeedByOrganization = (orgId) => {
    return combinedFeed.filter(item => item.organization_id === orgId);
  };

  return {
    combinedFeed,
    getFeedByType,
    getFeedByUser,
    getFeedByOrganization,
  };
}; 